import React from 'react';

import { TipoAtributo } from '@datatox-bi/util';
import { TextFilter } from './text/TextFilter';
// import { DateFilter } from './date/DateFilter';
import IntegerFilter from './number/IntegerFilter';

export const OperationWrapper = ({ cubo, metaAtributoSelected, disabled, filtro, onChangeFilter, preFiltros, preFiltrosServer }) => {
    if (!metaAtributoSelected || !metaAtributoSelected.tipo) return <></>;

    let filter;
    switch (metaAtributoSelected.tipo) {
        case TipoAtributo.TEXTO:
            filter = (
                <TextFilter
                    cubo={cubo}
                    metaAtributoSelected={metaAtributoSelected}
                    disabled={disabled}
                    onChangeFilter={onChangeFilter}
                    filtro={filtro}
                    preFiltros={preFiltros}
                    preFiltrosServer={preFiltrosServer}
                />
            );
            break;
        case TipoAtributo.NUMERICO_INTEIRO:
            filter = <IntegerFilter cubo={cubo} metaAtributoSelected={metaAtributoSelected} onChangeFilter={onChangeFilter} filtro={filtro} />;
            break;
        // case TipoAtributo.TIMESTAMP_MS:
        // case TipoAtributo.DATA_HORA:
        //     filter = <DateFilter cubo={cubo} metaAtributoSelected={metaAtributoSelected} onChangeFilter={onChangeFilter} filtro={filtro} />;
        //     break;
        default:
    }

    return <>{filter}</>;
};
